<template>
    <!-- <b-col lg="5" md="5" sm="3" class="filter-box new-activity d-flex" :control-size="controlSize"> -->
    <div class="filter-box new-activity" :class="align" :control-size="controlSize">
        <button class="page-action-btn" v-b-tooltip.hover :title="item.tooltip" v-for="(item, idx) in buttonsActions" :key="idx + 'buttons'"
            @click="item['action']()" :class="item.class">
            <img :src="item.img" v-if="!!item.img">
            <i v-else-if="!item.loading && !!item.faIcon" :class="item.faIcon" />
            <b-img v-else-if="!item.loading && !!item.icon" :src="item.icon" />
            {{ item.text }}
        </button>
        <b-dropdown id="dropdown-button" v-if="dropdownActions.length > 0" :disabled="dropdownDisabled" varient="link"
            toggle-class="text-decoration-none" class="btn badge blue-button badge-info btn-icon-text"
            :class="dropdownActions[0].dropdownButtonClass" no-caret>
            <template #button-content>
                <i class="fa fa-ellipsis-v text-light"></i>
            </template>
            <template v-for="(item, idx) in dropdownActions">
                <b-dropdown-header :key="idx + 'dropdown-header'" id="dropdown-header-label" v-if="!!item.divider">
                    {{ item.text }}
                </b-dropdown-header>
                <b-dropdown-item v-if="!item.divider" :key="idx + 'dropdown-item'" @click="item['action']()"
                    :disabled="item.disabled" :link-class="textDark">
                    <b-img :src="item.icon" />
                    {{ item.text }}
                </b-dropdown-item>
                <b-dropdown-divider :key="idx + 'dropdown-divider'" v-if="!item.divider"></b-dropdown-divider>
            </template>
        </b-dropdown>

        <!-- </button> -->
    </div>
</template>

<script>
export default {
    props: {
        buttonsActions: {
            type: Array,
            default: () => [],
        },
        dropdownTitle: {
            type: String,
            default: '',
        },
        dropdownActions: {
            type: Array,
            default: () => [],
        },
        dropdownDisabled: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
        },
        controlClass: { type: String, default: 'float-right' },
        controlSize: { type: String, default: 'sm' },
    },
    mounted() {
        const removeDropdown = this.$el.querySelector(
            '#dropdown-button__BV_toggle_'
        )
        if (removeDropdown !== null) {
            removeDropdown.classList.remove('dropdown-toggle')
            removeDropdown.classList.remove('btn-secondary')
        }
    },
    data() {
        return { textDark: 'text-dark' }
    }
}
</script>

<style></style>
